
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-stroke",attrs:{"stroke":"#798f8f","stroke-linecap":"round","d":"M15.414 7.405a7 7 0 0 1 0 2.19M7.405 1.586a7 7 0 0 1 2.19 0M1.586 9.595a7 7 0 0 1 0-2.19m8.009 8.009a7 7 0 0 1-2.19 0m6.758-2.8a7 7 0 0 1-1.549 1.55m0-11.327a7 7 0 0 1 1.55 1.549m-11.327 0a7 7 0 0 1 1.549-1.55m0 11.327a7 7 0 0 1-1.55-1.549M8.5 5v3.5m.5 3a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Z"}})])
          )
        }
      }
    